module.exports = __webpack_public_path__ + "img/tpc-32.a06c4965.jpg";